import { render, staticRenderFns } from "./projectSearch.vue?vue&type=template&id=cdfb556c&scoped=true"
import script from "./projectSearch.vue?vue&type=script&lang=js"
export * from "./projectSearch.vue?vue&type=script&lang=js"
import style0 from "./projectSearch.vue?vue&type=style&index=0&id=cdfb556c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cdfb556c",
  null
  
)

export default component.exports